import React from 'react';
import CardRender, {CardProps} from './CardRender';


export const Card=({children,...props}:CardProps):JSX.Element=>{
	return <CardRender{ ...props}>
		{children}
	</CardRender>;
};
